import { ComputedRef } from 'vue';
import { PreferenceItem } from 'features/settings/preferences/interfaces';
import { UserRoles } from 'features/residents/types/hubstr';
import {
  MEMBERS_IMPORT_DEFAULT_SCHEMA,
  MEMBERS_IMPORT_SCHEMA_SETTING_CODE,
  MEMBERS_IMPORT_SCHEMAS,
  MEMBERS_IMPORT_SETTING_CODE,
  MembersImportSchema,
} from 'features/residents/types/members-import';
import useStore from '~/store/useStore';

const getPreferences = (): PreferenceItem[] => (
  useStore().preferences as unknown as ComputedRef<PreferenceItem[]>
).value ?? [];

/**
 * Раскладка файла импорта из настройки клуба members_import.schema.
 * Неизвестное или пустое значение — дефолт full_name_phone, как делает бэк.
 */
export const getMembersImportSchema = (): MembersImportSchema => {
  const value = getPreferences().find((item) => item.code === MEMBERS_IMPORT_SCHEMA_SETTING_CODE)?.value;

  if (typeof value === 'string' && value in MEMBERS_IMPORT_SCHEMAS) {
    return value as MembersImportSchema;
  }

  console.warn('[FIX][MembersImport.schema] unknown club schema, using default', {
    value,
    fallback: MEMBERS_IMPORT_DEFAULT_SCHEMA,
  });
  return MEMBERS_IMPORT_DEFAULT_SCHEMA;
};

/**
 * Импорт участников доступен, только если в клубе включена настройка members_import.enabled
 * и у текущего пользователя есть роль ROLE_ADMIN (остальным ролям бэк отвечает 403).
 * Вызывается при рендере шапки, поэтому без логов.
 */
export const isMembersImportAvailable = (): boolean => {
  const preferences = getPreferences();
  const userRoles = (useStore().userRoles as unknown as ComputedRef<string[]>).value ?? [];

  const isEnabled = preferences.find((item) => item.code === MEMBERS_IMPORT_SETTING_CODE)?.value === true;

  return isEnabled && userRoles.includes(UserRoles.Admin);
};
